import React, { useState } from 'react';
import { useUserAndGameContext } from '../../contexts/UserAndGameContext';
import { Box, Typography, Button } from '@mui/material';
import './GameRulesPageNew.scss';
import RulesPageSection from './RulesPageSection';

const GameRulesPageNew = () => {
    const {
        gameData,
    } = useUserAndGameContext();

    const rules = gameData?.rulesPageInfo;
    const ruleTabs = rules?.ruleTabs;

    const [activeTab, setActiveTab] = useState(ruleTabs.length > 0 ? ruleTabs[0].tabName : null);

    // Use provided tabs or default ones
    const displayRuleTabs = ruleTabs?.length > 0 ? ruleTabs : null;
    
    // If we have tabs, use active tab sections; otherwise use all sections from default
    const activeSections = activeTab 
        ? displayRuleTabs.find(tab => tab.tabName === activeTab)?.sections || []
        : [];

    return (
        <Box sx={{ padding: '24px 0 32px 0' }}>
            <Box className='rules-page-text-group'>
                <Typography className='rules-page-header'>
                    {rules?.header}
                </Typography>

                {rules?.subHeader && (
                    <Typography className='rules-page-subheader'>
                        {rules?.subHeader}
                    </Typography>
                )}
            </Box>

            {/* Rule navigation tabs - Now with horizontal scroll */}
            {displayRuleTabs?.length > 1 && (
            <Box className='rules-page-tabs-container'>
                <Box className='rules-page-tabs-scroll-container'>
                <Box className='rules-page-tabs'>
                    {displayRuleTabs?.map((tab, index) => (
                    <Typography
                        key={index}
                        className={`rules-page-tab ${activeTab === tab.tabName ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.tabName)}
                    >
                        {tab.tabName}
                    </Typography>
                    ))}
                </Box>
                </Box>
            </Box>
            )}

            <Box className='rules-page-content'>
                {activeSections?.map((section, index) => (
                    <RulesPageSection
                        key={index}
                        title={section.title}
                        content={section.content}
                    />
                ))}
            </Box>
        </Box>
    );
}

export default GameRulesPageNew;